// @flow
import styled from 'styled-components'
import { Card, Table } from 'antd'


export const StyledSection = styled.section`
  height: 326px;
  width: 100%;
  min-width: 705px;
`

export const StyledCard = styled(Card)`
  height: 100%;
  width: 100%;
  
  .chartLabels{
      margin-left: 130px;
      margin-top: -22px;
  }
`


export const StyledTable = styled(Table)`
  
  & .ant-table-tbody>tr>td, .ant-table-thead>tr>th { 
    padding: 15px 0;
  }
  
`



// WEBPACK FOOTER //
// ./src/components/view-markets/style.js